<div
  class="bg-second-level p-5 rounded-lg h-full flex flex-col justify-center"
  [ngClass]="cardBorderBgColor()"
>
  <div class="mb-4" [class.text-center]="centered()">
    <h4
      class="text-lg font-semibold mb-0 truncate"
      [class.text-center]="centered()"
      [pTooltip]="hrProviderTitle()"
      tooltipPosition="top"
    >
      {{ hrProviderTitle() }}
    </h4>
    <p class="text-sm opacity-80 truncate" [pTooltip]="hrToolName()" tooltipPosition="top">
      {{ hrToolName() }}
    </p>
  </div>

  <div>
    <h5 class="text-sm opacity-60 mb-3" [class.text-center]="centered()">
      {{ 'common.functions' | transloco }} ({{ moduleFunctionsCount() }}):
    </h5>
    <div>
      @for (moduleFunction of moduleFunctionSystemRecordings(); track $index) {
        <div class="flex items-center gap-2">
          <app-module-function-status-badge
            [type]="moduleFunction.inScope ? 'IN_SCOPE' : 'OUT_OF_SCOPE'"
          />
          <app-module-function-status-badge [type]="moduleFunction.plannedAction" />
          <span class="text-sm mb-1">
            {{ translationMap().get(moduleFunction.moduleFunctionDirectusId) | translateDirectus }}
          </span>
        </div>
      }
    </div>
  </div>
</div>
